import API from "./API";

class CounterpartiesAPI extends API {
  constructor(parameters = {}) {
    super("/Counterparty", parameters);
  }
  getAllTypes() {
    return this.submit("get", `${this.endpoint}/CounterpartyTypes`);
  }
  getCounterpartiesHistory() {
    return this.submit("get", `${this.endpoint}/GetCounterpartiesHistory`);
  }

  createLegalPerson(data) {
    return this.submit("post", `${this.endpoint}/LegalPerson`, data);
  }

  updateLegalPerson(id, data) {
    return this.submit("put", `${this.endpoint}/LegalPerson/${id}`, data);
  }

  deleteLegalPerson(itn, rrc){
    return this.submit('delete', `${this.endpoint}/LegalPerson/itn=${itn}&rrc=${rrc}`)
  }

  createNaturalPerson(data) {
    return this.submit("post", `${this.endpoint}/NaturalPerson`, data);
  }

  updateNaturalPerson(id, data) {
    return this.submit("put", `${this.endpoint}/NaturalPerson/${id}`, data);
  }

  deleteNaturalPerson(itn){
    return this.submit('delete', `${this.endpoint}/NaturalPerson/itn=${itn}`)
  }

  createSoleProprietorship(data) {
    return this.submit("post", `${this.endpoint}/SoleProprietorship`, data);
  }

  updateSoleProprietorship(id, data) {
    return this.submit("put", `${this.endpoint}/SoleProprietorship/${id}`, data);
  }

  deleteSoleProprietorship(itn){
    return this.submit('delete', `${this.endpoint}/SoleProprietorship/itn=${itn}`)
  }

  searchCounterparty(query){
    return this.submit('get', `${this.endpoint}/Search/query=${query}`)
  }
  async downloadAllVatCounterparties() {
    return await this.export("post", `${this.endpoint}/downloadAllVatCounterparties`);
  }
}

export default CounterpartiesAPI;
